import { format } from "date-fns";

import type { BirthingFlowsheetFormValues } from "@/encounters/components/EncounterLabor/flowsheet-forms/birthing/types/birthing-form";
import type { BirthingFlowsheetFormSchemaType } from "@/encounters/components/EncounterLabor/flowsheet-forms/birthing/zod-schemas/birthing-flowsheet-form";
import { localToUtcTimeString } from "@/utils/timeUtils";

/** Empty form values with blank date/time for QuestionnaireResponse hydrate. */
export function getEmptyBirthingFlowsheetFormValues(): BirthingFlowsheetFormValues {
  return {
    birthingDate: null,
    birthingTime: null,
    birthingCrownDateTime: null,
    birthingHeadDateTime: null,
    birthingBodyDateTime: null,
    birthingType: null,
    birthingPosition: null,
    birthingInWater: null,
    birthingInWaterOther: "",
    birthingFetalPresentation: null,
    birthingDeliveryMethod: null,
    birthingDeliveryMethodOther: "",
    birthingNotes: "",
    birthingSignatureInitials: [],
  };
}

/** Quick-add defaults with the current local date and time. */
export function getDefaultBirthingFlowsheetFormValues(): BirthingFlowsheetFormValues {
  const now = new Date();
  const localTime = format(now, "HH:mm:ss");
  return {
    ...getEmptyBirthingFlowsheetFormValues(),
    birthingDate: now,
    birthingTime: localToUtcTimeString(localTime),
  };
}

export function normalizeBirthingFlowsheetFormValues(
  parsed: BirthingFlowsheetFormSchemaType,
): BirthingFlowsheetFormValues {
  // Keep explicit null date/time so edit hydrate does not fill the current clock.
  const empty = getEmptyBirthingFlowsheetFormValues();
  return {
    birthingDate: parsed.birthingDate !== undefined ? parsed.birthingDate : empty.birthingDate,
    birthingTime: parsed.birthingTime !== undefined ? parsed.birthingTime : empty.birthingTime,
    birthingCrownDateTime:
      parsed.birthingCrownDateTime !== undefined
        ? parsed.birthingCrownDateTime
        : empty.birthingCrownDateTime,
    birthingHeadDateTime:
      parsed.birthingHeadDateTime !== undefined
        ? parsed.birthingHeadDateTime
        : empty.birthingHeadDateTime,
    birthingBodyDateTime:
      parsed.birthingBodyDateTime !== undefined
        ? parsed.birthingBodyDateTime
        : empty.birthingBodyDateTime,
    birthingType: parsed.birthingType ?? empty.birthingType,
    birthingPosition: parsed.birthingPosition ?? empty.birthingPosition,
    birthingInWater: parsed.birthingInWater ?? empty.birthingInWater,
    birthingInWaterOther: parsed.birthingInWaterOther ?? empty.birthingInWaterOther,
    birthingFetalPresentation: parsed.birthingFetalPresentation ?? empty.birthingFetalPresentation,
    birthingDeliveryMethod: parsed.birthingDeliveryMethod ?? empty.birthingDeliveryMethod,
    birthingDeliveryMethodOther:
      parsed.birthingDeliveryMethodOther ?? empty.birthingDeliveryMethodOther,
    birthingNotes: parsed.birthingNotes ?? empty.birthingNotes,
    birthingSignatureInitials: parsed.birthingSignatureInitials ?? empty.birthingSignatureInitials,
  };
}
